import React, { useState } from 'react';
import { COLORS, FlexView, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';

import { BorderedBox, HorizontalLine } from 'screens/student-details/styled-comps';
import PlusIcon from 'img/plus.svg';
import MinusIcon from 'img/minus.svg';

import { trackEvent } from 'modules/analytics';

const TitleText = styled(Text)`
  position: absolute;
  top: -9px;
  padding: 0 8px;
  margin-left: 8px;
  background: ${COLORS.WHITE};
`;

const ContentWrapper = styled(FlexView)`
  margin-top: 24px;
  width: 100%;
  padding-bottom: 24px;
`;

const CollapsibleViewTitle = styled(Text)`
  max-width: 100%;
`;

const EmptyContentWrapper = styled(Row)`
  padding: 0 16px;
`;

const NotInUseText = styled(Text)`
  margin-left: 8px;
`;

const CollapsibleViewRoot = styled(FlexView)`
  padding: 0 16px;
  width: 100%;
`;

const CollapsibleViewTitleWrapper = styled(Row)`
  width: 100%;
  cursor: pointer;
`;

const CollapsibleViewContentWrapper = styled(Row)`
  height: ${({ isOpen }) => (isOpen ? 'fit-content' : 0)};
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  transition: 'display 2s ease-in-out, height 2s ease-in-out';
  margin-top: 24px;
`;

export default function CollapsibleBox({ title, options, style }) {
  return (
    <BorderedBox padding="0" borderRadius="4px" style={style} marginTop="12px">
      <TitleText color={COLORS.COLA_LIGHTER} variant="eyebrow2">
        {title}
      </TitleText>
      <ContentWrapper>
        {options.map((option, index) => {
          const { title: optionTitle, content, isCollapsible } = option;

          return (
            <Row key={index}>
              {isCollapsible ? (
                <CollapseView title={optionTitle} content={content}>
                  <CollapsibleViewTitle variant="body1Regular">
                    {content}
                  </CollapsibleViewTitle>
                </CollapseView>
              ) : (
                <EmptyContentWrapper alignItems="center">
                  <Text variant="body1Medium">{optionTitle}</Text>
                  {content && <NotInUseText variant="body3">{content}</NotInUseText>}
                </EmptyContentWrapper>
              )}
              {index < options.length - 1 ? (
                <HorizontalLine marginTop="24px" marginBottom="24px" />
              ) : null}
            </Row>
          );
        })}
      </ContentWrapper>
    </BorderedBox>
  );
}

function CollapseView({ children, title }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    if (!isOpen) {
      trackEvent(title);
    }
    setIsOpen(prev => !prev);
  };

  return (
    <CollapsibleViewRoot>
      <CollapsibleViewTitleWrapper
        justifyContent="space-between"
        onClick={handleOpen}
        alignItems="center"
      >
        <Text variant="body1Medium">{title}</Text>
        <img src={isOpen ? MinusIcon : PlusIcon} alt="" />
      </CollapsibleViewTitleWrapper>
      <CollapsibleViewContentWrapper isOpen={isOpen}>
        {children}
      </CollapsibleViewContentWrapper>
    </CollapsibleViewRoot>
  );
}
